import {useState, useEffect, createElement, Suspense} from "react";
import {Paysafe} from "./Paysafe";
import {Button, Spinner} from "parts";
import {useTranslation, Trans} from "react-i18next";
import {setProfile, setRegister, setTrack} from "utils";
import {BookEnum} from "_business";
import {PaymentPayPal, PaymentStripeWallet, PaymentStripeCard} from "./LazyPayments"

export function PaymentWindow({children, data, book, nextUrl, onClose, paymentType, payInfo = true}) {
  const
    {t, i18n} = useTranslation('common', {keyPrefix: 'payment.window'}),
    {t: t1} = useTranslation('common', {keyPrefix: 'payment'})

  const
    [productData, setProductData] = useState(),
    [messagePayment, setMessagePayment] = useState(null)

  useEffect(() => {
    document.body.classList.add('pop')

    return () => document.body.classList.remove('pop')
  }, [])

  useEffect(() => {
    if (!data)
      return

    setProductData({
      ...(
        book
          ? {
            id: data.id,
            currency: data.currency,
            currencySymbol: data.currencySymbol,
            ...data[book],
            name: data[book]?.name[i18n.resolvedLanguage],
            fullPrice: data[BookEnum.charisma]?.price,
            price: data[BookEnum.charisma]?.full_price,
            promo: undefined,
            full_price: undefined,
          }
          : data
      ),
      uid: window._uid || window.localStorage.getItem('uid'),
      email: window._email || window.localStorage.getItem('email') || '',
      type: book,
    })

    if (!book) {
      const product = `${data.name.replace(' ', '')}_${data.fullPrice}`
      setRegister({product})
      setProfile({product, plan: data.period})
    }

    // mixpanel.track_pageview({page: 'payment'})
    // mixpanel.track('payment')
    // window.localStorage.setItem('product', product)
  }, [data])

  useEffect(() => {
    for (const item of paymentList) {
      if (item.applePay)
        item.name = t1('applePay')
      else if (item.googlePay)
        item.name = t1('googlePay')
      else if (item.paypal)
        item.name = t1('payPal')
      else if (item.credit)
        item.name = t('credit')
    }

    setPaymentList([...paymentList])
  }, [i18n.resolvedLanguage])

  const [paymentList, setPaymentList] = useState([
    {
      name: '...',
      pay: true,
      component: PaymentStripeWallet,
    },
    {
      name: t1('payPal'),
      paypal: true,
      img: <img src={'/static/img/paywall/paypal-pay.png'} width={52} height={20} alt={t1('payPal')}/>,
      component: PaymentPayPal,
    },
    {
      name: t('credit'),
      credit: true,
      img: <img src={'/static/img/paywall/card-pay.png'} width={207} height={20} alt={t('credit')}/>,
      component: PaymentStripeCard,
    },
  ])

  const
    pi =
      paymentList.findIndex(({pay, credit}) =>
        (paymentType === 'credit' && credit) ||
        (paymentType === 'applePay' && pay)
      ),
    [paymentIndex, setPaymentIndex] = useState(pi >= 0 ? pi : 0),
    [resetTrigger, setResetTrigger] = useState(0)

  useEffect(() => setPaymentIndex(0), [resetTrigger])

  useEffect(() => {
    // if (!window.userSelectPayemnt) {
    //   window.userSelectPayemnt = true
    //   return
    // }

    const
      pay = paymentList[paymentIndex],
      type = pay.credit ? 'Card' : pay.name

    if (type !== '...')
      setTrack('payment_method_selected', {type})
  }, [paymentIndex])

  function handleStripeResult(result) {
    // console.log('handleStripeResult', result)

    const pIndex = paymentList.findIndex(({pay}) => pay)

    if (pIndex >= 0) {
      if (result?.applePay) {
        paymentList[pIndex] = {
          ...paymentList[pIndex],
          applePay: true,
          name: t1('applePay'),
          img: <img src={'/static/img/paywall/apple-pay.png'} width={35} height={20} alt={t1('applePay')}/>,
        }
        setTrack('payment_method_selected', {type: 'Apple Pay'})
      } else if (result?.googlePay) {
        paymentList[pIndex] = {
          ...paymentList[pIndex],
          googlePay: true,
          name: t1('googlePay'),
          img: <img src={'/static/img/paywall/google-pay.png'} width={35} height={20} alt={t1('googlePay')}/>,
        }
        setTrack('payment_method_selected', {type: 'Google Pay'})
      } else
        paymentList.splice(pIndex, 1)

      setPaymentList([...paymentList])

      if (paymentType) {
        const
          pi =
            paymentList.findIndex(({pay, credit}) =>
              (paymentType === 'credit' && credit) ||
              (paymentType === 'applePay' && pay)
            )

        if (pi >= 0)
          setPaymentIndex(pi)
      }
    }
  }

  const getPeriod = (field, first) => {
    const periods = t('periods', {returnObjects: true})

    return periods[data?.period]?.[first] || periods[data?.period]?.[field] || data?.period
  }

  return (
    <>
      <div className="shadow"/>
      <div className={!messagePayment ? 'window' : undefined}>
        <Button variant={'link'} className={'back close'} aria-label={'Close'} onClick={onClose}>
          <img src={'/static/img/icon/close.svg'} alt="x" width={16} height={16}/>
        </Button>

        <div className="items center w-100">
          <h4 className='text-center'>{t('title')}</h4>
          {
            // !data?.discount &&
            // <p className={'notice'}>
            //   {t1('notice', {
            //     currencySymbol: data?.currencySymbol,
            //     fullPrice: data?.fullPrice,
            //     period: getPeriod('text')
            //   })}
            // </p>
          }

          <p className='row wide'>
            {t('total')}

            <span>
              {
                book
                  ?
                  <>
                    <s className={'note xl me-2'}>{data[book].full_price}</s>
                    <em>{data[book].price} {data.currency}</em>
                  </>
                  :
                  <>
                    <s className={'note xl me-2'}>{data.standardPrice || data.price}</s>
                    <em>{data.fullPrice} {data.currency}</em>
                  </>
              }
            </span>
          </p>

          <h2 style={{fontSize: 24, lineHeight: '32px'}}>{t('header')}</h2>

          <div className='items gap-3 w-100'>
            {
              paymentList.map((item, index) => {
                const checked = paymentIndex === index || !item.credit

                return (
                  <div key={index} className={'w-100 items' + (checked ? ' active' : '')}
                       onClick={() => setPaymentIndex(index)}>
                    {
                      item.credit &&
                      <Button variant="white" className="item center"
                              style={{backgroundColor: 'rgba(255, 255, 255, 0.84)'}}>
                        <strong className='small'>{item.name}</strong>
                        {item.img}
                      </Button>
                    }

                    {
                      checked && item.component && productData &&
                      <Suspense fallback={<Spinner/>}>
                        {createElement(
                          item.component, {
                            data: productData,
                            onResult: handleStripeResult,
                            setMessagePayment,
                            nextUrl,
                            isWindow: true,
                            onResetPayment: () => setResetTrigger(prev => prev + 1)
                          }
                        )}
                      </Suspense>
                    }
                  </div>
                )
              })
            }
          </div>

          {
            payInfo &&
            <>
              <Paysafe payment={true}/>
              <img width={350} height={32} src={'/static/img/paywall/secure.png'} alt=""/>
            </>
          }

          {children}

          {
            !children && data?.price &&
            <p className={'note md fw-400'}>
              <Trans i18nKey={`foot`} t={t}
                     values={{
                       period: getPeriod('value', 'value-1'),
                       dialect: getPeriod('dialect'),
                       // currency: data?.currency,
                       price: data?.price,
                       currencySymbol: data?.currencySymbol,
                       fullPrice: data?.fullPrice,
                     }}
              >
                You agree that <strong>$9.99</strong> will be charged as an intro offer,
                then <strong>$20.39</strong> will be automatically billed every 1 month until you cancel in settings.
              </Trans>
            </p>
          }
        </div>
      </div>
    </>
  )
}